<ss-cookie-consent-popup></ss-cookie-consent-popup>

<div class="login-container">
  <div class="popup-top">
    <div class="popup-top-left">
      <h4>
        <ng-container *ngIf="isLoggedIn">
          logged in
        </ng-container>
    
        <ng-container *ngIf="!isLoggedIn">
          log in
        </ng-container>
      </h4>
    </div>

    <div class="popup-top-right">
      <div class="popup-close">
        <a class="popup-close-button"
          mat-icon-button
          aria-label="close"
          [routerLink]="returnPathNotLoggedInDefault"
          (click)="handleClose($event)">

          <mat-icon>close</mat-icon>
        </a>
      </div>
    </div>
  </div>

  <div class="font-size-small" *ngIf="isLoggedIn">
    <div class="loading-container">
      <div class="loading-spinner">
        <mat-spinner 
          mode="indeterminate"
          diameter="16">
        </mat-spinner>
      </div>
      <div class="loading-text">
        Redirecting...
      </div>
    </div>
  </div>
  
  <div class="login-form-container" *ngIf="!isLoggedIn">
    <div class="login-button--google">
      <asl-google-signin-button
        type="standard"
        size="large">
      </asl-google-signin-button>
    </div>
  </div>



  
  <div class="login-form-container" *ngIf="false">
    <div class="login-button--google">
      <asl-google-signin-button
        type="standard"
        size="large">
      </asl-google-signin-button>
    </div>

    <div class="margin-v-30">
      <ss-form-separator>
        <em>or</em>
      </ss-form-separator>
    </div>

    <div class="login-form-container">

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="login-form-input-container">
          <mat-form-field appearance="outline">
            <mat-label>email</mat-label>
            <input matInput type="text" 
              formControlName="email" 
              autocomplete="email"
              class="form-control" 
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />

            <mat-error *ngIf="submitted && f.email.hasError('required')">email is required</mat-error>
            <mat-error *ngIf="submitted && f.email.hasError('pattern')">must be an email</mat-error>
          </mat-form-field>
      
          <mat-form-field appearance="outline">
            <mat-label>password</mat-label>
            <input matInput type="password" 
              formControlName="password" 
              class="form-control" 
              autocomplete="current-password"
              [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />

            <mat-error *ngIf="submitted && f.password.hasError('required')">password is required</mat-error>
            <mat-error *ngIf="submitted && f.password.hasError('incorrect')">incorrect password</mat-error>
          </mat-form-field>
        </div>
        
        <div class="login-form-button-container">
          <button [disabled]="isLoading" class="btn btn-primary flex-0">
              continue
          </button>

          <a (click)="handleSelectRegister()" 
            class="link-secondary flex-0">
              huh?
          </a>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="returnPath" 
  class="login-note-container">
  <span><em>next stop:</em></span>

  <code class="background-none">{{ returnPath }}</code>
</div>
